import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { Bolt, Monitor, SunMedium, Circle, Zap } from "lucide-react";
import heroImg from "../../../assets/purepower-home-slider-1.webp";
import Video from "../../../assets/1.mp4";
import Video2 from "../../../assets/2.mp4";
import Video3 from "../../../assets/3.mp4";

import productImg from "../../../assets/purepower-3-lite.png";
import productImg2 from "../../../assets/purepower-3.png";
import productImg3 from "../../../assets/purepower-5.png";
import productImg4 from "../../../assets/purepower-12.png";
import productImg5 from "../../../assets/purepower-20.png";
import KeyFeature1 from "../../../assets/key-feature-res-01.jpeg";
import KeyFeature2 from "../../../assets/key-feature-res-02.jpeg";
import KeyFeature3 from "../../../assets/key-feature-res-03.jpeg";
import KeyFeature4 from "../../../assets/key-feature-res-04.jpeg";
import KeyFeature5 from "../../../assets/key-feature-res-05.jpeg";
import KeyFeature6 from "../../../assets/key-feature-res-06.jpeg";
import KeyFeature7 from "../../../assets/key-feature-res-07.jpeg";
import KeyFeature8 from "../../../assets/key-feature-res-08.jpeg";
import KeyFeature9 from "../../../assets/key-feature-res-09.jpeg";
import KeyFeature10 from "../../../assets/key-feature-res-10.jpeg";
import KeyFeature11 from "../../../assets/key-feature-res-11.jpeg";
import KeyFeature12 from "../../../assets/key-feature-res-12.jpeg";
import KeyFeature13 from "../../../assets/key-feature-res-13.jpeg";
import KeyFeature14 from "../../../assets/key-feature-res-14.jpeg";
import KeyFeature15 from "../../../assets/key-feature-res-15.jpeg";

const products = [
  {
    Name: "PuREPower 3.0 Lite",
    RatedPower: "3000 W",

    Input: {
      Voltage: "230 VAC",
      SelectableVoltage: "190–260 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "230 VAC ±5%",
      SurgePower: "6000 VA",
      Efficiency: "~97%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppts: "1",
      PvVoltage: "450 VDC",
      PvPower: "5000 W",
      PvCurrent: "18 A",
      MppRange: "60–450 VDC",
      SolarCharge: "100 A",
      AcCharge: "60 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      NominalVoltage: "24 V",
      Capacity: "2 kWh",
      ChargeCurrent: "10 A",
      DischargeCurrent: "90 A",
      FullCharge: "29.3 V",
      FullDischarge: "21 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      AntiIslanding: "Integrated",
      AcOverCurrent: "Integrated",
      ShortCircuit: "Integrated",
      Overload: "Integrated",
      TempHigh: "Integrated",
      FanBlock: "Integrated",
    },

    General: {
      Dimensions: "375×155×440 mm",
      Installation: "Wall-mounted",
      Weight: "28 kg",
      Warranty: "5 years",
      ExtendedWarranty: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "PuREPower Home 3.0",
    RatedPower: "3000 VA / 3000 W",

    Input: {
      Voltage: "230 VAC",
      SelectableVoltage: "190–260 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "230 VAC ±5%",
      SurgePower: "6000 VA",
      Efficiency: "~97%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppts: "1",
      PvVoltage: "450 VDC",
      PvPower: "8500 W",
      PvCurrent: "27 A",
      MppRange: "60–450 VDC",
      SolarCharge: "100 A",
      AcCharge: "60 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "1",
      NominalVoltage: "48 V",
      Capacity: "3 kWh",
      ChargeCurrent: "10 A",
      DischargeCurrent: "90 A",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      AntiIslanding: "Integrated",
      AcOverCurrent: "Integrated",
      ShortCircuit: "Integrated",
      Overload: "Integrated",
      TempHigh: "Integrated",
      FanBlock: "Integrated",
    },

    General: {
      Dimensions: "362×155×728 mm",
      Installation: "Wall-mounted",
      Weight: "34 kg",
      Warranty: "5 years",
      ExtendedWarranty: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "PuREPower Home 5.0",
    RatedPower: "5500 W",

    Input: {
      Voltage: "230 VAC",
      SelectableVoltage: "190–260 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "230 VAC ±5%",
      SurgePower: "11000 VA",
      Efficiency: "~97%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppts: "1",
      PvVoltage: "450 VDC",
      PvPower: "8500 W",
      PvCurrent: "27 A",
      MppRange: "60–450 VDC",
      SolarCharge: "100 A",
      AcCharge: "100 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "1",
      NominalVoltage: "48 V",
      Capacity: "5 kWh",
      ChargeCurrent: "20 A",
      DischargeCurrent: "90 A",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      AntiIslanding: "Integrated",
      AcOverCurrent: "Integrated",
      ShortCircuit: "Integrated",
      Overload: "Integrated",
      TempHigh: "Integrated",
      FanBlock: "Integrated",
    },

    General: {
      Dimensions: "382×155×773 mm",
      Installation: "Wall-mounted",
      Weight: "49 kg",
      Warranty: "5 years",
      ExtendedWarranty: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "PuREPower Home 12.0",
    RatedPower: "12000 W",

    Input: {
      Voltage: "230 VAC",
      SelectableVoltage: "190–260 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "230 VAC ±5%",
      SurgePower: "22000 VA",
      Efficiency: "~94%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppts: "2",
      PvVoltage: "450 VDC",
      PvPower: "15000 W",
      PvCurrent: "2×27 A",
      MppRange: "60–450 VDC",
      SolarCharge: "150 A",
      AcCharge: "150 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "2",
      NominalVoltage: "48 V",
      Capacity: "12 kWh",
      ChargeCurrent: "20A×2",
      DischargeCurrent: "90A×2",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      AntiIslanding: "Integrated",
      AcOverCurrent: "Integrated",
      ShortCircuit: "Integrated",
      Overload: "Integrated",
      TempHigh: "Integrated",
      FanBlock: "Integrated",
    },

    General: {
      Dimensions: "550×155×1190 mm",
      Installation: "Wall-mounted",
      Weight: "80 kg",
      Warranty: "5 years",
      ExtendedWarranty: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },

  {
    Name: "PuREPower Home 20.0",
    RatedPower: "20000 W",

    Input: {
      Voltage: "3×415 VAC",
      SelectableVoltage: "380–440 VAC",
      Frequency: "50/60 Hz Auto",
    },

    Output: {
      AcVoltage: "415 VAC ±5%",
      SurgePower: "36000 VA",
      Efficiency: "~94%",
      Switching: "On/Off Grid/Hybrid",
      Transfer: "10 ms",
      Waveform: "Pure sine wave",
    },

    Solar: {
      Charger: "MPPT",
      Mppts: "3",
      PvVoltage: "450 VDC",
      PvPower: "3×8500 W",
      PvCurrent: "3×27 A",
      MppRange: "60–450 VDC",
      SolarCharge: "360 A",
      AcCharge: "360 A",
    },

    Battery: {
      Technology: "Lithium Ion",
      Qty: "5",
      NominalVoltage: "48 V",
      Capacity: "20 kWh",
      ChargeCurrent: "60 A",
      DischargeCurrent: "90A×5",
      FullCharge: "54.3 V",
      FullDischarge: "40 V",
    },

    Protection: {
      Bms: "5th Gen BMS",
      Ip: "IP65",
      AntiIslanding: "Integrated",
      AcOverCurrent: "Integrated",
      ShortCircuit: "Integrated",
      Overload: "Integrated",
      TempHigh: "Integrated",
      FanBlock: "Integrated",
    },

    General: {
      Dimensions: "490×540×1325 mm",
      Installation: "Floor standing",
      Weight: "200 kg",
      Warranty: "5 years",
      ExtendedWarranty: "12 years",
      Noise: "<50 dB",
      Thermal: "Nano PCM",
      Communication: "BT, WiFi, AI Cloud",
    },
  },
];

const SpecCard = ({ title, data }) => (
  <div
    className="
      rounded-3xl
      overflow-hidden
      bg-gradient-to-br
      from-[#2a2a2a]
      via-[#252525]
      to-[#1c1c1c]
      border border-[#3a3a3a]
      shadow-[0_15px_40px_rgba(0,0,0,0.35)]
      hover:border-[#F5B13C]
      hover:-translate-y-1
      hover:shadow-[0_20px_50px_rgba(245,177,60,0.18)]
      transition-all
      duration-300
    "
  >
    {/* Header */}
    <div className="bg-black border-b border-[#F5B13C]/30 px-6 py-5">

      <h3 className="uppercase tracking-[4px] text-sm font-bold text-[#F5B13C]">
        {title}
      </h3>

    </div>

    {/* Body */}
    <div className="max-h-[280px] overflow-y-auto custom-scroll">

      {Object.entries(data).map(([key, value], index) => (

        <div
          key={key}
          className={`
            flex
            justify-between
            items-center
            gap-6
            px-6
            py-4
            border-b
            border-white/10
            transition
            duration-200

            ${
              index % 2 === 0
                ? "bg-white/[0.02]"
                : "bg-transparent"
            }

            hover:bg-[#F5B13C]/10
          `}
        >

          <span className="text-gray-300 font-medium">
            {key.replace(/([A-Z])/g, " $1")}
          </span>

          <span className="text-white font-semibold text-right">
            {value}
          </span>

        </div>

      ))}

    </div>
  </div>
);

const PurePowerResidential = () => {
  const [active, setActive] = useState(0);
  const item = products[active];
    const keyFeatures = [
    KeyFeature1,
    KeyFeature2,
    KeyFeature3,
    KeyFeature4,
    KeyFeature5,
    KeyFeature6,
    KeyFeature7,
    KeyFeature8,
    KeyFeature9,
    KeyFeature10,
    KeyFeature11,
    KeyFeature12,
    KeyFeature13,
    KeyFeature14,
    KeyFeature15,
    ];
  return (
 
    <div>
        <section className="bg-black">
            {/* Hero Section */}
            <div className="relative min-h-screen sm:h-screen bg-cover bg-center flex items-center" style={{backgroundImage: `url(${heroImg})`,}}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/35" />

                {/* Content */}
                <div className="relative z-10 px-4 sm:px-8 md:px-24 max-w-[700px] py-12 sm:py-0">

                <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight">
                    Elevating Consumer <br />
                    Experience
                </h1>

                <p className="mt-4 sm:mt-8 text-white text-base sm:text-lg md:text-xl lg:text-3xl leading-relaxed">
                    Enjoy uninterrupted power,
                    seamless integration
                    and lower electricity bills
                </p>

                </div>
            </div>
        </section>
      
        {/* Video Experience */}
        <section className="bg-[#ffffff] py-8 md:py-16 lg:py-16 mt-8 px-4 sm:px-6">
            <div className="max-w-[1500px] mx-auto">
                <div className="text-center mb-8 sm:mb-12 md:mb-16">
                    <p className="text-green-600 font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm">
                        PuREPower Home
                    </p>
                    <h2 className="mt-3 sm:mt-5 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black">
                        Meet India's most advanced power backup product
                    </h2>
                    <p className="mt-3 sm:mt-4 text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-2">
                    Seamlessly integrates an inverter, solar power,
                    and intelligent AI. Power your ACs, geysers,
                    and appliances without a hiccup — all in a sleek
                    design built for Indian homes.                    
                    </p>
                </div>

                <div className="grid gap-6 sm:gap-8 lg:grid-cols-3">
                    {[
                        {
                            label: "Solar",
                            title: "Real-time Solar Charging",
                            desc: "Watch PuREPower harvest solar energy during the day and store it efficiently.",
                            src: Video,
                        },
                        {
                            label: "Backup",
                            title: "Seamless Backup",
                            desc: "See the system keep your home powered during outages without interruption.",
                            src: Video2,
                        },
                        {
                            label: "AI",
                            title: "Smart Energy Management",
                            desc: "Discover how AI optimizes power use for a more reliable home energy experience.",
                            src: Video3,
                        },
                    ].map((item, index) => (
                        <div key={item.label} className="rounded-2xl sm:rounded-3xl overflow-hidden bg-white shadow-xl border border-gray-200">
                            <div className="relative h-auto overflow-hidden">
                                <video
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    className="w-full h-full object-cover"
                                >
                                    <source src={item.src} type="video/mp4" />
                                </video>
                                <div className="absolute left-3 sm:left-4 top-3 sm:top-4 inline-flex items-center gap-2 sm:gap-3 rounded-full bg-black/70 px-3 sm:px-4 py-2 text-white text-xs sm:text-sm font-semibold">
                                    <span className="inline-flex h-6 sm:h-8 w-6 sm:w-8 items-center justify-center rounded-full bg-green-500 text-xs">
                                        {`0${index + 1}`}
                                    </span>
                                    {item.label}
                                </div>
                            </div>
                            <div className="p-4 sm:p-6">
                                <h3 className="text-lg sm:text-2xl font-semibold text-black">
                                    {item.title}
                                </h3>
                                <p className="mt-2 sm:mt-3 text-sm sm:text-base text-gray-600 leading-6 sm:leading-8">
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        {/* Features Section */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 lg:py-16 px-4 sm:px-6">
            <div className="max-w-[1500px] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-16">
                    {/* Card 1 */}
                    <div>
                        <div className="mb-8 sm:mb-14">
                            <div className="w-20 h-20 rounded-2xl bg-green-50 flex border border-green-200 items-center justify-center">
                                <Bolt
                                size={38}
                                strokeWidth={2}
                                className="text-green-600"
                                />
                            </div>
                        </div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1b2430] leading-tight">
                        Seamless Backup, <br />Powerful Energy
                        </h2>
                        <p className="mt-6 sm:mt-10 text-base sm:text-lg md:text-xl text-[#1f2937] leading-relaxed sm:leading-[2]">
                        Experience comfort with PuREPower Home.
                        PuREPower Home runs all your essential home
                        appliances like ACs, Geysers, Mixer Grinders etc
                        even during power cuts with ease, ensuring
                        complete peace of mind.
                        </p>
                    </div>
                    {/* Card 2 */}
                    <div>
                        <div className="mb-8 sm:mb-14">
                            <div className="w-20 h-20 rounded-2xl bg-green-50 flex border border-green-200 items-center justify-center">
                                <Monitor
                                size={38}
                                strokeWidth={2}
                                className="text-green-600"
                                />
                            </div>
                        </div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1b2430] leading-tight">
                            Elegant Design, <br />
                            Superior User Experience
                        </h2>
                        <p className="mt-6 sm:mt-10 text-base sm:text-lg md:text-xl text-[#1f2937] leading-relaxed sm:leading-[2]">
                        PuREPower Home's all-in-one design and smart
                        features put updates at your fingertips.
                        Easy installation and zero maintenance ensure
                        uninterrupted power and peace of mind.
                        Its sleek, modern design complements any
                        home interior.
                        </p>
                    </div>
                    {/* Card 3 */}
                    <div>
                        <div className="mb-8 sm:mb-14">
                            <div className="w-20 h-20 rounded-2xl bg-green-50 flex border border-green-200 items-center justify-center">
                                <SunMedium
                                size={38}
                                strokeWidth={2}
                                className="text-green-600"
                                />
                            </div>
                        </div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1b2430] leading-tight">
                            Solar Ready, <br />
                            Power Up
                        </h2>
                        <p className="mt-6 sm:mt-10 text-base sm:text-lg md:text-xl text-[#1f2937] leading-relaxed sm:leading-[2]">
                        PuREPower Home integrates seamlessly with your
                        rooftop solar system, storing excess energy
                        during the day for use at night or during cloudy
                        periods. Ensuring your home is powered all the
                        time and saving happens naturally.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        {/* Our Product Section */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-20 px-4 sm:px-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-[42px] font-semibold text-black text-center mb-8 sm:mb-12">
                Our Products
            </h1>
            <div className="max-w-[1300px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[42%_58%] gap-6 sm:gap-8 items-start">
                    {/* LEFT IMAGE */}
                    <div>
                        <div className="rounded-lg sm:rounded-xl overflow-hidden max-w-[520px]">
                            <img
                                src={productImg}
                                alt="PuREPower Home"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="text-black max-w-[720px]">
                        <h3 className="text-xl sm:text-2xl md:text-[32px] font-semibold">
                        PuREPower Home 3.0 Lite
                        </h3>
                        <p className="mt-2 text-sm sm:text-base md:text-sm text-gray-600 leading-relaxed sm:leading-9">
                        PuREPower Home is India's first advanced
                        power backup system designed to run ACs,
                        geysers, mixers, coolers and essential
                        appliances efficiently.
                        </p>

                        {/* Specifications */}
                        <div className="mt-4">
                            <h4 className="text-lg sm:text-2xl md:text-[28px] font-bold mb-2">
                                Key Specification
                            </h4>
                            <div className="space-y-1 text-xs sm:text-sm md:text-sm">
                                {[
                                ["Capacity", "3KVA / 2KWh"],
                                ["Backup time", "Up to 4 Hours"],
                                ["Standard Warranty", "5 Years"],
                                ["Extended Warranty", "12 Years"],
                                ["Smart AI", "Yes"],
                                ["Solar Support", "Yes"],
                                ["Advanced thermal management system", "Yes"],
                                ].map(([label, value]) => (
                                <div
                                    key={label}
                                    className="flex justify-between border-b border-gray-700 pb-2 sm:pb-3"
                                >
                                    <span>{label}</span>
                                    <span>{value}</span>
                                </div>
                                ))}
                            </div>
                        </div>

                        {/* Colors */}
                        <div className="mt-4">
                            <p className="text-sm sm:text-base md:text-lg mb-2">
                                Color
                            </p>
                            <div className="flex gap-2">
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-orange-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-gray-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-yellow-300" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white border" />
                            </div>
                        </div>

                        {/* Button */}
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Home%203.0%20Lite"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 px-6 sm:px-8 py-2 bg-[#F5B13C] text-black rounded-lg sm:rounded-xl text-sm sm:text-lg md:text-xl font-bold hover:scale-105 transition inline-block text-center"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </div>
        </section>

        {/* Product 2 */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-20 px-4 sm:px-6">
            <div className="max-w-[1300px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[42%_58%] gap-6 sm:gap-8 items-start">
                    {/* LEFT IMAGE */}
                    <div>
                        <div className="rounded-lg sm:rounded-xl overflow-hidden max-w-[520px]">
                            <img
                                src={productImg2}
                                alt="PuREPower Home 3.0"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="text-black max-w-[720px]">
                        <h3 className="text-xl sm:text-2xl md:text-[32px] font-semibold">
                        PuREPower Home 3.0
                        </h3>
                        <p className="mt-2 text-sm sm:text-base md:text-sm text-gray-600 leading-relaxed sm:leading-9">
                        PuREPower Home is India’s first and only
                        advanced power backup system to run ACs,
                        Geysers, Mixers, Coolers and other essential
                        appliances efficiently.
                        </p>
                        {/* Specifications */}
                        <div className="mt-4">
                            <h4 className="text-lg sm:text-2xl md:text-[28px] font-bold mb-2">
                                Key Specification
                            </h4>
                            <div className="space-y-1 text-xs sm:text-sm md:text-sm">
                                {[
                                ["Capacity", "3 kVA / kWh"],
                                ["Backup time", "Up to 6 hours *"],
                                ["Standard Warranty", "5 years"],
                                ["Extended Warranty", "12 years *"],
                                ["Smart AI", "Yes"],
                                ["Solar Support", "Yes"],
                                ["Advanced thermal management system", "Yes"],
                                ["5th Gen Power Electronics", "Yes"],
                                ].map(([label, value]) => (
                                <div key={label} className="flex justify-between border-b border-gray-700 pb-2 sm:pb-3">
                                    <span>{label}</span>
                                    <span>{value}</span>
                                </div>
                                ))}
                            </div>
                        </div>

                        {/* Colors */}
                        <div className="mt-4">
                            <p className="text-sm sm:text-base md:text-lg mb-2">
                                Color
                            </p>
                            <div className="flex gap-2">
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-[#f59e0b]" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-[#6b7280]" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-[#fde68a]" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white border" />
                            </div>
                        </div>

                        {/* Button */}
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Home%203.0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 px-6 sm:px-8 py-2 bg-[#F5B13C] text-black rounded-lg sm:rounded-xl text-sm sm:text-lg md:text-xl font-bold hover:scale-105 transition inline-block text-center"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </div>
        </section>

        {/* Product 3 */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-20 px-4 sm:px-6">
            <div className="max-w-[1300px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[42%_58%] gap-6 sm:gap-8 items-start">
                    {/* LEFT IMAGE */}
                    <div>
                        <div className="rounded-lg sm:rounded-xl overflow-hidden max-w-[520px]">
                            <img
                                src={productImg3}
                                alt="PuREPower Home 5.0"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="text-black max-w-[720px]">
                        <h3 className="text-xl sm:text-2xl md:text-[32px] font-semibold">
                        PuREPower Home 5.0
                        </h3>
                        <p className="mt-2 text-sm sm:text-base md:text-sm text-gray-600 leading-relaxed sm:leading-9">
                        PuREPower Home is India’s first and only
                        advanced power backup system to run ACs,
                        Geysers, Mixers, Coolers and essential
                        appliances while delivering higher backup
                        capacity and seamless performance.
                        </p>
                        {/* Specifications */}
                        <div className="mt-4">
                            <h4 className="text-lg sm:text-2xl md:text-[28px] font-bold mb-2">
                                Key Specification
                            </h4>
                            <div className="space-y-1 text-xs sm:text-sm md:text-sm">
                                {[
                                ["Capacity", "5 kVA / kWh"],
                                ["Backup time", "Up to 8 hours *"],
                                ["Standard Warranty", "5 years"],
                                ["Extended Warranty", "12 years *"],
                                ["Smart AI", "Yes"],
                                ["Solar Support", "Yes"],
                                ["Advanced thermal management system", "Yes"],
                                ["5th Gen Power Electronics", "Yes"],
                                ].map(([label, value]) => (
                                <div key={label} className="flex justify-between border-b border-gray-700 pb-2 sm:pb-3">
                                    <span>{label}</span>
                                    <span>{value}</span>
                                </div>
                                ))}
                            </div>
                        </div>

                        {/* Colors */}
                        <div className="mt-4">
                            <p className="text-sm sm:text-base md:text-lg mb-2">
                                Color
                            </p>
                            <div className="flex gap-2">
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-orange-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-gray-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-yellow-300" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white border" />
                            </div>
                        </div>
                        {/* Button */}
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Home%205.0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 px-6 sm:px-8 py-2 bg-[#F5B13C] text-black rounded-lg sm:rounded-xl text-sm sm:text-lg md:text-xl font-bold hover:scale-105 transition inline-block text-center"
                        >
                            Enquire Now
                        </a>

                    </div>
                </div>
            </div>
        </section>

        {/* Product 4 */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-20 px-4 sm:px-6">
            <div className="max-w-[1300px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[42%_58%] gap-6 sm:gap-8 items-start">
                    {/* LEFT IMAGE */}
                    <div>
                        <div className="rounded-lg sm:rounded-xl overflow-hidden max-w-[520px]">
                            <img
                                src={productImg4}
                                alt="PuREPower Home 12.0"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                    {/* RIGHT CONTENT */}
                    <div className="text-black max-w-[720px]">
                        <h3 className="text-xl sm:text-2xl md:text-[32px] font-semibold">
                        PuREPower Home 12.0
                        </h3>
                        <p className="mt-2 text-sm sm:text-base md:text-sm text-gray-600 leading-relaxed sm:leading-9">
                        PuREPower Home is India’s first and only
                        advanced power backup system to run ACs,
                        Geysers, Mixers, Coolers and other essential
                        appliances with higher capacity and extended
                        backup performance.
                        </p>
                        {/* Specifications */}
                        <div className="mt-4">
                            <h4 className="text-lg sm:text-2xl md:text-[28px] font-bold mb-2">
                                Key Specification
                            </h4>
                            <div className="space-y-1 text-xs sm:text-sm md:text-sm">
                                {[
                                ["Capacity", "12 kVA / kWh"],
                                ["Backup time", "Up to 12 hours *"],
                                ["Standard Warranty", "5 years"],
                                ["Extended Warranty", "12 years *"],
                                ["Smart AI", "Yes"],
                                ["Solar Support", "Yes"],
                                ["Advanced thermal management system", "Yes"],
                                ["5th Gen Power Electronics", "Yes"],
                                ].map(([label, value]) => (
                                <div key={label} className="flex justify-between border-b border-gray-700 pb-2 sm:pb-3">
                                    <span>{label}</span>
                                    <span>{value}</span>
                                </div>
                                ))}
                            </div>
                        </div>
                        {/* Colors */}
                        <div className="mt-4">
                            <p className="text-sm sm:text-base md:text-lg mb-2">
                                Color
                            </p>
                            <div className="flex gap-2">
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-orange-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-gray-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-yellow-300" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white border" />
                            </div>
                        </div>
                        {/* Button */}
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Home%2012.0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 px-6 sm:px-8 py-2 bg-[#F5B13C] text-black rounded-lg sm:rounded-xl text-sm sm:text-lg md:text-xl font-bold hover:scale-105 transition inline-block text-center"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </div>
        </section>

        {/* Product 5 */}
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-20 px-4 sm:px-6">
            <div className="max-w-[1300px] mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-[42%_58%] gap-6 sm:gap-8 items-start">
                    {/* LEFT IMAGE */}
                    <div>
                        <div className="rounded-lg sm:rounded-xl overflow-hidden max-w-[520px]">
                            <img
                                src={productImg5}
                                alt="PuREPower Home 20.0"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="text-black max-w-[720px]">
                        <h3 className="text-xl sm:text-2xl md:text-[32px] font-semibold">
                        PuREPower Home 20.0
                        </h3>
                        <p className="mt-2 text-sm sm:text-base md:text-sm text-gray-600 leading-relaxed sm:leading-9">
                        PuREPower Home is India’s first and only
                        advanced power backup system built to run
                        3 Phase Residential Lifts, ACs, Geysers,
                        Mixers, Coolers and essential home appliances
                        with seamless high-capacity backup.
                        </p>
                        {/* Specifications */}
                        <div className="mt-4">
                            <h4 className="text-lg sm:text-2xl md:text-[28px] font-bold mb-2">
                                Key Specification
                            </h4>
                            <div className="space-y-1 text-xs sm:text-sm md:text-sm">
                                {[
                                ["Capacity", "20 kVA"],
                                ["Backup time", "Up to 18 hours *"],
                                ["Standard Warranty", "5 years"],
                                ["Extended Warranty", "12 years *"],
                                ["Smart AI", "Yes"],
                                ["Solar Support", "Yes"],
                                ["Advanced thermal management system", "Yes"],
                                ["5th Gen Power Electronics", "Yes"],
                                ].map(([label, value]) => (
                                <div key={label} className="flex justify-between border-b border-gray-700 pb-2 sm:pb-3">
                                    <span>{label}</span>
                                    <span>{value}</span>
                                </div>
                                ))}
                            </div>
                        </div>
                        {/* Colors */}
                        <div className="mt-4">
                            <p className="text-sm sm:text-base md:text-lg mb-2">
                                Color
                            </p>
                            <div className="flex gap-2">
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-orange-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-gray-500" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-yellow-300" />
                                <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white border" />
                            </div>
                        </div>
                        {/* Button */}
                        <a
                            href="https://wa.me/919944211899?text=Hello%20I%27m%20interested%20in%20PuREPower%20Home%2020.0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 px-6 sm:px-8 py-2 bg-[#F5B13C] text-black rounded-lg sm:rounded-xl text-sm sm:text-lg md:text-xl font-bold hover:scale-105 transition inline-block text-center"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="bg-[#f5f5f5] text-black py-12 sm:py-16 md:py-24 px-4 sm:px-6">
            <div className="max-w-[1400px] mx-auto">
                <p className="text-green-600 font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm">
                    Technical Details
                </p>
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mt-3">
                    PuREPower Home Specifications
                </h2>
                {/* Tabs */}
                <div className="mt-8 sm:mt-10 flex flex-wrap gap-2 sm:gap-3">
                    {products.map((p, index) => (
                        <button
                        key={index}
                        onClick={() => setActive(index)}
                        className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full transition text-xs sm:text-sm md:text-base ${
                            active === index
                            ? "bg-[#F5B13C] text-white"
                            : "bg-[#303030] text-white"
                        }`}
                        >
                        {p.Name}
                        </button>
                    ))}
                </div>

                {/* Table */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-10 sm:mt-12">
                    <SpecCard title="Input" data={item.Input} />
                    <SpecCard title="Output" data={item.Output} />
                    <SpecCard title="Solar Charger" data={item.Solar} />
                    <SpecCard title="Battery" data={item.Battery} />
                    <SpecCard title="Protection" data={item.Protection} />
                    <SpecCard title="General" data={item.General} />
                </div>
            </div>
        </section>
        <section className="bg-[#f5f5f5] py-12 sm:py-16 md:py-24 px-4 sm:px-6">

            <div className="max-w-[1450px] mx-auto">

                <p className="text-green-600 font-semibold uppercase tracking-[0.35em] text-xs sm:text-sm">
                    Key Features
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4 md:gap-6 mt-8 sm:mt-10 md:mt-14">

                    {keyFeatures.map((image, index) => (

                        <div
                            key={index}
                            className="
                                overflow-hidden
                                rounded-lg sm:rounded-2xl
                                shadow-md
                                hover:shadow-xl
                                transition-all
                                duration-300
                                group
                            "
                        >

                            <img
                                src={image}
                                alt={`Key Feature ${index + 1}`}
                                className="
                                    w-full
                                    h-full
                                    object-cover
                                    group-hover:scale-105
                                    transition-transform
                                    duration-500
                                "
                            />

                        </div>

                    ))}

                </div>

            </div>

        </section>
    </div>
  );
};

export default PurePowerResidential;